import * as React from "react";

function SvgCurve2(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path className="curve-2_svg__st2" d="M-10 207.6h1620S1430.8 23.8 1138.3 23.8C884 23.8 234.9 140.1-10 197.9v9.7z" /></svg>;
}

export default SvgCurve2;